import { createSelector } from 'reselect'
import { RootState } from 'store'

export const FFSelector = createSelector(
  (state: RootState) => state.featureFlags,
  state => state
)
export const featureFlagsSelector = createSelector(FFSelector, state => state.value)
